export default {"src":"/_next/static/media/coupons.801646a1.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};